import * as React from "react";
import { Card, IconButton } from "@grandvisionhq/common";
import { Icon } from "@grandvisionhq/icons";
import { Alert } from "@grandvisionhq/iris-ui";
/* empty css                 */
const ProductItemNotFound = ({ product, onRemove, labels }) => {
  const { slug, sku } = product;
  return /* @__PURE__ */ React.createElement(Card, { key: `${slug}-${sku}`, layout: "horizontal", className: "try-in-store-modal__product-item" }, /* @__PURE__ */ React.createElement(
    Card.Image,
    {
      src: "",
      alt: labels.imageAlt,
      className: "try-in-store-modal__product-item__image"
    }
  ), /* @__PURE__ */ React.createElement(Card.Content, { center: true, className: "try-in-store-modal__product-item__content" }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      onClick: onRemove,
      className: "try-in-store-modal__product-item__remove",
      variant: "ghost",
      "aria-label": labels.remove
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "close" })
  ), /* @__PURE__ */ React.createElement(Alert, { variant: "error", className: "alert-m-default try-in-store-modal__product-item__alert" }, labels.notFound)));
};
export {
  ProductItemNotFound
};
//# sourceMappingURL=ProductItemNotFound.js.map
